import { VerificationStatus } from 'src/common/models/verificationModels';

export interface ProcessDTO {
  verificationId: string;
  verificationStatus: VerificationStatus;
}

export enum FlowType {
  SmarFlow = 'SMART_FLOW',
  Regular = 'REGULAR',
}

export interface ProcessStatusDTO {
  verificationId: string;
  verificationScoring: number;
  verificationStatus: VerificationStatus;
  verificationFlow: FlowType;
}

export interface DispatchResultDTO {
  status: VerificationStatus;
  verificationId: string;
  frontType: string;
  redirectUrl: string;
}
